export default __webpack_public_path__ + "static/media/purpleTheme-girl.593f901e.svg";